/* eslint-disable @typescript-eslint/no-explicit-any */
// (The "anys" are coming from a third party library)

const lowerCase = (str: string): string => str[0].toLowerCase() + str.slice(1)

const mapObject = (obj: any): any =>
	Object.fromEntries(Object.entries(obj).map(([k, v]) => [lowerCase(k), v]))
const mapArray = (arr: any[]): any => arr.map((obj) => mapObject(obj))

const mapAlbum = (album: any): Album => {
	const mappedAlbum = mapObject(album)
	mappedAlbum.number = mappedAlbum.id
	delete mappedAlbum.id
	mappedAlbum.catalogue = mapObject(album.Catalogue)
	return mappedAlbum
}

const formatComposerName = (composer: any): string => {
	const { firstName, lastName } = composer

	const composerName = [firstName, lastName].filter((name) => !!name).join(' ')

	return composerName
}

export const mapTracksFromAlgolia = (
	algoliaTracks: any[],
	preferredOrder: number[] = null
): Track[] => {
	const tracks = mapArray(algoliaTracks).map((track: any) => ({
		...track,
		album: mapAlbum(track.album),
		composers: [...mapArray(track.composers)].map((composer) => ({
			...composer,
			name: formatComposerName(composer),
		})),
	}))

	if (preferredOrder) {
		const orderedTracks = preferredOrder
			.map((id) => tracks.find((item) => item.id === id))
			.filter((track) => track)

		return orderedTracks
	}

	return tracks
}
